
export interface UntrusiveOptions {
  bgColor: string;
  barColor: string;
  height?: number;
}
